import React from 'react';
import './SecSub.css'

const SecSub = (props) => {
    return ( 
        <p className='SecSub'>{props.SecSub}</p>
     );
}
 
export default SecSub;